import { OptiClient } from '../../../services/OptiClient';
import getBaseUrl from './getBaseUrl';
var optiClient = new OptiClient({
    BASE: getBaseUrl(),
});
export default optiClient;
